@if (showDropdown) {
  @if (layout === 'none') {
    <kendo-combobox #kendo_combo_sites [data]="_sitesFiltered" [filterable]="true"
      (filterChange)="_handleSitesFilter($event)" [suggest]="suggest" [placeholder]="placeholder" [ngModel]="_value"
      (valueChange)="_onValueChange($event)" [textField]="textField" [valueField]="valueField" [class]="inputClass"
      [disabled]="isDisabled || disabled" [required]="required">
    </kendo-combobox>
  }
  @if (layout === 'form-group') {
    <div class="form-group special_style_formgroup">
      <label for="code" class="control-label">{{ labelText }}</label>
      <kendo-combobox #kendo_combo_sites [data]="_sitesFiltered" [filterable]="true"
        (filterChange)="_handleSitesFilter($event)" [suggest]="suggest" [placeholder]="placeholder" [ngModel]="_value"
        (valueChange)="_onValueChange($event)" [textField]="textField" [valueField]="valueField" [class]="inputClass"
        [disabled]="isDisabled || disabled" [required]="required">
      </kendo-combobox>
    </div>
  }
  @if (layout === 'row') {
    <div style="margin-bottom: 1%;" class="row">
      <div class="col-12 col-xl-6">
        <div class="row">
          <label for="code" class="col-3 pad-right-0 control-label">{{ labelText }}</label>
          <div class="col-9 combobox_contaainer">
            <kendo-combobox #kendo_combo_sites [data]="_sitesFiltered" [filterable]="true"
              (filterChange)="_handleSitesFilter($event)" [suggest]="suggest" [placeholder]="placeholder" [ngModel]="_value"
              (valueChange)="_onValueChange($event)" [textField]="textField" [valueField]="valueField" [class]="inputClass"
              [disabled]="isDisabled || disabled" [required]="required">
            </kendo-combobox>
          </div>
        </div>
      </div>
    </div>
  }
  @if (layout === 'transaction') {
    <div class="form-group special_style_formgroup">
      <div class="row">
        <div class="col-2">
          <label class="control-label">{{ labelText }}</label>
        </div>
        <div class="col-10" [class]="inputContainerClass">
          <kendo-combobox #kendo_combo_sites [data]="_sitesFiltered" [filterable]="true"
            (filterChange)="_handleSitesFilter($event)" [suggest]="suggest" [placeholder]="placeholder" [ngModel]="_value"
            (valueChange)="_onValueChange($event)" [textField]="textField" [valueField]="valueField" [class]="inputClass"
            [disabled]="isDisabled || disabled" [required]="required">
          </kendo-combobox>
        </div>
      </div>
    </div>
  }
}